import { AxiosRequestConfig } from 'axios';
import { getAxios } from '../../lib/axios.tsx';
import { ClientEmailAttachment } from '../../features/inbox/types/Activity.ts';
import { ApiEndpoints } from '../../constants/endpoints/apiEndpoints.ts';

export const downloadFile = async (url: string, fileName: string, config?: AxiosRequestConfig) => {
  const axios = getAxios();
  const response = await axios.get<Blob>(url, { ...config, responseType: 'blob' });
  return downloadObjectBlob(response.data, fileName);
};

export const downloadObjectBlob = async (blob: Blob, fileName: string) => {
  const anchor = document.createElement('a');

  const objectUrl = window.URL.createObjectURL(blob);
  anchor.href = objectUrl;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(objectUrl);
};

export const downloadBase64ExcelFile = async (base64: string, fileName: string) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  await downloadObjectBlob(
    new Blob([new Uint8Array(byteNumbers)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    fileName
  );
};
export const activityDownloadFile = async (item: ClientEmailAttachment) => {
  await downloadFile(ApiEndpoints.dataAccess.getFile(item.FileHandle!), item.FileName);
};

export const downloadCrmFile = async (fileHandle: string, fileName: string) => {
  await downloadFile(ApiEndpoints.dataAccess.getFile(fileHandle), fileName);
};
